<template>
  <div
    class="close-btn aspect-square"
    @click="emit('close')"
  >
    <i class="icon xxl-icon icon--close" />
  </div>
</template>

<script setup lang="ts">
interface Emits {
  (e: "close"): void;
}

const emit = defineEmits<Emits>();
</script>
